<template>
  <!-- 这个是认证 -->
  <div>
    <div class="link_authentication" style="">
      <div class="linkurl">
        <img src="@/img/init.png" class="link1_img" alt="" />
      </div>
      <!-- <div class="link_text" v-if="groupInfo.state == 1">
        {{ $t("account_management.authentication.text") }}
      </div> -->
      <div class="link_text" v-if="groupInfo.state == 1">
        {{ $t("account_management.authentication.text1") }}
      </div>
      <div class="link_text" v-if="groupInfo.state == 2">
        {{ $t("account_management.authentication.text2") }}
      </div>
      <div class="link_text" v-if="groupInfo.state == 0">
        {{ $t("account_management.authentication.text3") }}
      </div>
    </div>
    <div class="main">
      <div class="list_box">
        <div class="list_title">
          {{ $t("account_management.authentication.developer") }}
        </div>
        <div class="list_text">{{ groupInfo.nickname }}</div>
      </div>

      <div class="list_box">
        <div class="list_title">
          {{ $t("account_management.authentication.progress") }}
        </div>
        <div class="list_progress_box">
          <div class="progress_box">
            <div class="progress" :style="'width:' + process + '%'">
              {{ process }}%
            </div>
          </div>
        </div>
      </div>
      <div class="list_box">
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.type") }}
        </div>
        <div class="list_text">
          {{
            groupInfo.groupType == 0
              ? $t("account_management.authentication.individual_person")
              : $t("account_management.authentication.company")
          }}
          <span class="text">
            ({{ $t("account_management.authentication.email") }}
            <span @click="copy(configs)" class="copy CU"
              >{{ configs
              }}{{ $t("account_management.authentication.copy") }}</span
            >
            )
          </span>
        </div>
      </div>

      <div
        class="list_box MG25 wid367"
        :class="isidName && !idName ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.account") }}
        </div>
        <div>
          <input
            type="text"
            v-model="idName"
            :placeholder="
              $t('account_management.authentication.please_account')
            "
            class="TGA_INPUT input367"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="isidName">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.account_kong")
          }}</span>
        </div>
      </div>

      <div
        class="list_box MG25 wid367"
        :class="isidNo && !idNo ? 'TGA_BR' : ''"
        v-if="groupInfo.groupType == 0"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.id") }}
        </div>
        <div>
          <input
            type="text"
            v-model="idNo"
            :placeholder="$t('account_management.authentication.please_id')"
            class="TGA_INPUT input367"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="isidNo">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.id_kong")
          }}</span>
        </div>
      </div>

      <div
        class="list_box MG25 wid367"
        :class="isidNo && !idNo ? 'TGA_BR' : ''"
        v-else
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.idNo") }}
        </div>
        <div>
          <input
            type="text"
            v-model="idNo"
            :placeholder="$t('account_management.authentication.please_idNo')"
            class="TGA_INPUT input367"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="isidNo">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.idNo_kong")
          }}</span>
        </div>
      </div>
      <!-- 上传图片 -->
      <div
        class="list_up_box list_box MG25 wid367"
        :class="isimageUrl && !imageUrl ? 'TGA_BR' : ''"
      >
        <div class="list_up_title list_title">
          <span class="must">*</span>
          {{
            groupInfo.groupType == 0
              ? $t("account_management.authentication.idtext")
              : $t("account_management.authentication.idNotext")
          }}
        </div>
        <div class="updata_box">
          <!-- 上传图片 -->
          <div class="updata CU">
            <el-upload
              :action="upload_url"
              :drag="false"
              class="avatar-uploader"
              :http-request="up_load"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="imageUrl && !upload_loading"
                :src="imageUrl"
                class="avatar"
              />

              <img
                v-if="!imageUrl && !upload_loading"
                class="upload_img"
                style=""
                :src="$t('account_management.authentication.uploadimg')"
                alt=""
              />
              <img
                v-if="upload_loading"
                src="@/img/up_loading.gif"
                class="upload_img"
                alt=""
              />
            </el-upload>
          </div>
          <div class="up_preview_box">
            <div class="up_preview_text">
              {{ $t("account_management.authentication.sample") }}
            </div>
            <div class="up_preview_url CU">
              <img class="up_preview_img" src="@/img/preview.jpg" alt="" />
            </div>
          </div>

          <div class="TGA_INPUT_INIT" style="height: 90px" v-if="isimageUrl">
            <img width="15" height="15" src="@/img/mistake.png" alt="" />
            <span class="span">{{
              groupInfo.groupType == 0
                ? $t("account_management.authentication.uploadid")
                : $t("account_management.authentication.uploadidNo")
            }}</span>
          </div>
        </div>

        <div class="upload_init">
          <div class="upload_dian"></div>
          {{
            groupInfo.groupType == 0
              ? $t("account_management.authentication.uploadidtext")
              : $t("account_management.authentication.uploadidNotext")
          }}
        </div>
      </div>
      <div
        class="list_box MG25 wid367"
        :class="iscountry && country == null ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.country") }}
        </div>
        <div class="list_select">
          <el-select
            class="select_wid"
            v-model="country"
            :placeholder="$t('account_management.authentication.select')"
          >
            <el-option
              v-for="(item, index) in product"
              :key="index"
              :label="item.country"
              :value="index"
            ></el-option>
          </el-select>
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="iscountry">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.please_country")
          }}</span>
        </div>
      </div>
      <div
        class="list_box MG25 wid367"
        :class="istype && type == null ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.currency_type") }}
        </div>
        <div class="list_select">
          <el-select
            class="select_wid"
            v-model="type"
            :placeholder="$t('account_management.authentication.select')"
          >
            <el-option
              v-for="(item, index) in product"
              :key="index"
              :label="item.currency"
              :value="index"
            ></el-option>
          </el-select>
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="istype">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">
            {{ $t("account_management.authentication.type_kong") }}</span
          >
        </div>
      </div>
      <div
        class="list_box MG25 wid367"
        :class="isbankName && !bankName ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.bankName") }}
        </div>
        <div>
          <input
            type="text "
            v-model="bankName"
            :placeholder="
              $t('account_management.authentication.please_bankName')
            "
            class="TGA_INPUT input367"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="isbankName">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.bankName")
          }}</span>
        </div>
      </div>
      <div
        class="list_box MG25 wid367"
        :class="isbankAccount && !bankAccount ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("account_management.authentication.bankAccount") }}
        </div>
        <div>
          <input
            type="text"
            v-model="bankAccount"
            :placeholder="
              $t('account_management.authentication.please_bankAccount')
            "
            class="TGA_INPUT input367"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="isbankAccount">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.please_bankAccount")
          }}</span>
        </div>
      </div>

      <div
        class="list_box MG25 wid367"
        :class="isbanksite && !banksite ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <!-- <span class="must">*</span> -->
          {{ $t("account_management.authentication.bank_site") }}
        </div>
        <div>
          <input
            type="text "
            v-model="banksite"
            class="TGA_INPUT input367"
            :placeholder="$t('account_management.authentication.address')"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="isbanksite">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">
            {{ $t("account_management.authentication.bank_kong") }}</span
          >
        </div>
      </div>
      <div
        class="list_box MG25 wid367"
        :class="isCode && !code ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <!-- <span class="must">*</span> -->
          {{ $t("account_management.authentication.swift_code") }}
        </div>
        <div>
          <input
            type="text "
            v-model="code"
            class="TGA_INPUT input367"
            :placeholder="$t('account_management.authentication.code_please')"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="false">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span class="span">{{
            $t("account_management.authentication.code")
          }}</span>
        </div>
      </div>

      <div v-if="groupInfo.state != 1" class="CU btn" @click="send">
        {{ $t("account_management.authentication.send_review") }}
      </div>

      <div
        v-if="groupInfo.state == 1"
        class="CU btn"
        style="background-color: #dddddd"
      >
        {{ $t("account_management.authentication.audit") }}
      </div>

      <a-modal :visible="previewVisible" :footer="null" @cancel="Click_URL"
        ><img alt="example" style="width: 100%" :src="previewImage"
      /></a-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configarea from "@/config/area.json";
import configsite from "@/config/site.json";
import configinvoice from "@/config/invoice.json";
import configs from "@/utils/config.js";
export default {
  data() {
    return {
      configs: configs.serviceEmail(),
      invoice: configinvoice,
      product: configsite,
      previewVisible: false,
      previewImage: "",
      imageUrl: "",
      upload_url: "",
      upload_loading: false,
      groupInfo: {},
      // 开户名
      idName: null,
      //身份证号码或者社会信用代码
      idNo: null,
      // 国家
      country: null,
      // 货币类型
      type: null,
      // 银行名称
      bankName: null,
      // 银行卡号
      bankAccount: null,
      // 银行地址
      banksite: null,
      // Swift code
      code: null,
      // 判断
      iscountry: false,
      istype: false,
      isbankName: false,
      isbankAccount: false,
      isbanksite: false,
      isCode: false,
      isidName: false,
      isidNo: false,
      isimageUrl: false,
      isinvoiceType: false,
      process: 50,
    };
  },
  computed: {},
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions("user", [
      "tipMessage",
      "FileUpload",
      "getUserInfo",
      "updateUserInfoExt",
    ]),
    // 获取认证数据
    async loadData() {
      const res = await this.getUserInfo({
        $axios: this.$axios,
      });
      if (res.code == 200) {
        if (res.data.extInfo.certifyInfo) {
          var data = res.data.extInfo.certifyInfo;
          this.groupInfo = data;
          this.idName = data.idName;
          this.idNo = data.idNo;
          this.imageUrl = data.idImage;
          this.bankAccount = data.bankAccount;
          this.country = data.bank.country;
          this.bankName = data.bank.bankName;
          this.type = data.bank.type;
          this.banksite = data.bank.banksite;
          this.code = data.bank.code;
          this.process = 100;
        }
        var baseInfo = res.data.extInfo.baseInfo;
        this.groupInfo = {
          ...this.groupInfo,
          groupType: baseInfo.groupType,
          nickname: res.data.nickname,
        };
      }
      console.log(res);
    },

    // 提交认证
    send() {
      if (!this.check()) {
        return;
      }
      var self = this;
      var obj = {
        idName: this.idName,
        idNo: this.idNo,
        idImage: this.imageUrl,
        bank: {
          country: this.country,
          type: this.type,
          banksite: this.banksite,
          bankName: this.bankName,
          code: this.code,
        },
        bankAccount: this.bankAccount,
        state: 1,
      };
      console.log("obj", obj);

      this.$confirm({
        title: this.$t("account_management.authentication.send_review"),
        content: this.$t("account_management.authentication.isaudit"),
        okText: this.$t("account_management.authentication.ok"),
        cancelText: this.$t("account_management.authentication.cancel"),
        onOk() {
          self.Censor(obj);
        },
        onCancel() {},
      });
    },

    async Censor(obj) {
      var self = this;
      var res = await this.updateUserInfoExt({
        $axios: this.$axios,
        key: "certifyInfo",
        value: obj,
      });
      if (res.code == 200) {
        self.tipMessage({
          context: this.$t("account_management.authentication.sendsuccess"),
        });
        self.groupInfo.state = 1;
      }
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.tipMessage({
          context: this.$t("account_management.authentication.upimgerror"),
        });
        return false;
      }
      if (!isLt2M) {
        this.tipMessage({
          context: this.$t("account_management.authentication.upimgerror2"),
        });
        return false;
      }
      this.upload_loading = true;

      return true;
    },
    async Upload(file) {
      var res = await this.FileUpload({
        $axios: this.$axios,
        file: file,
      });
      console.log(res);
      if (res.stateCode == 1) {
        this.$message.success(
          this.$t("account_management.authentication.upsuccess")
        );
        this.imageUrl = res.resultInfo.data;
        this.upload_loading = false;
      } else {
        this.$message.error(
          this.$t("account_management.authentication.uperror")
        );
      }
    },
    up_load(file) {
      // this.imageUrl   =file.name
      this.Upload(file.file);
      console.log("上传图片了啊", file.file);
    },
    // 点击查看图片
    showImg(text) {
      this.previewImage = text;
      this.previewVisible = true;
    },
    Click_URL() {
      this.previewVisible = false;
    },

    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(
        this.$t("account_management.authentication.copysuccess")
      );
      oInput.remove();
    },

    check() {
      var switchs = true;
      this.isidName = false;
      this.isidNo = false;
      this.isimageUrl = false;
      this.iscountry = false;

      this.isbankName = false;
      this.isbankAccount = false;

      if (!this.idName) {
        this.isidName = true;
        switchs = false;
      }

      if (!this.idNo) {
        this.isidNo = true;
        switchs = false;
      }

      if (!this.imageUrl) {
        this.isimageUrl = true;
        switchs = false;
      }

      if (this.country == null) {
        this.iscountry = true;
        switchs = false;
      }

      if (!this.bankName) {
        this.isbankName = true;
        switchs = false;
      }

      if (!this.bankAccount) {
        this.isbankAccount = true;
        switchs = false;
      }

      return switchs;
    },
  },
};
</script>

<style scoped="scoped">
.main {
  box-sizing: border-box;
  padding: 50px 0 91px 250px;
}
.list_box {
  height: 40px;
  position: relative;
  color: #666666;
  font-size: 14px;
}
.list_title {
  width: 220px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  position: absolute;
  left: -250px;
  top: 0;
  white-space: nowrap;
}
.list_text {
  height: 40px;
  line-height: 40px;
}
.list_progress_box {
  height: 40px;
  display: flex;
  align-items: center;
}
.progress_box {
  box-sizing: border-box;
  width: 301px;
  height: 15px;
  background-color: #f3f3f3;
  border-radius: 2px;
  /* border: solid 1px #e5e5e5; */
}
.progress {
  width: 50%;
  height: 100%;
  color: #ffffff;
  background-color: #23d3be;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list_text .text {
  color: #f65651;
  font-size: 12px;
}
.list_text .text .copy {
  color: #4990fa;
}

.input367 {
  width: 367px;
  height: 40px;
  border-radius: 4px;
  /* border: solid 1px #e5e5e5; */
}
.list_up_box {
  height: 120px;
  position: relative;
  color: #666666;
  font-size: 14px;
}
.list_up_title {
  height: 90px;
  color: #666666;
  font-size: 14px;
  line-height: 90px;
}
.updata_box {
  height: 90px;
  display: flex;
  justify-content: space-between;
  width: 367px;
}
.updata {
  width: 90px;
  height: 90px;
  position: relative;
}
.up_preview_box {
  display: flex;
  align-items: center;
}
.up_preview_text {
  font-size: 14px;
  color: #666666;
  margin-right: 25px;
}
.up_preview_url {
  width: 90px;
  height: 90px;
  border-radius: 4px;
}
.up_preview_img {
  width: 100%;
  height: 100%;
}

.upload_img {
  width: 90px;
  height: 90px;
  z-index: 1;
}
.upload {
  opacity: 0;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 90px;
  height: 90px;
}
.avatar {
  width: 90px;
  height: 90px;
}
.upload_init {
  margin-top: 19px;
  font-size: 12px;
  color: #aaaaaa;
  display: flex;
  align-items: center;
  position: absolute;
  top: 88px;
  left: 0px;
  width: 700px;
}
.upload_dian {
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background-color: #aaaaaa;
  margin-right: 11px;
}
.select_wid {
  width: 176px;
  height: 40px;
}
.list_select_jp {
  width: 367px;
  display: flex;
  justify-content: space-between;
}
.btn {
  width: 367px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 16px;
  margin-top: 30px;
}

.link_authentication {
  width: 900px;
  height: 30px;
  background-color: #fbf7cf;
  margin: 26px auto 0;
  border: solid 1px #f6e3ca;
  display: flex;
  align-items: center;
  padding-left: 11px;
}
.linkurl {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  margin-right: 9px;
}
.link1_img {
  width: 14px;
  height: 14px;
}
.link_text {
  color: #ebbe4c;
  font-size: 12px;
}

.name {
  width: 367px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main .input {
  width: 136px;
  height: 40px;
}
.span {
  line-height: 0;
}
</style>

<style>
.phone_BOX .el-input__inner {
  box-sizing: border-box;
  height: 40px;
  padding-left: 15px;
  font-size: 14px;
  color: rgba(28, 28, 28, 1);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e5e5e5;
  padding-right: 25px;
}
.phone_BOX .el-input__suffix {
  right: 0;
}
.TGA_BR .el-input__inner {
  border: solid 1px #f65651 !important;
}

.elm_site .el-input__inner {
  box-sizing: border-box;
  width: 117px;
  height: 40px;
  /* border: none; */
  padding-left: 15px;
  font-size: 14px;
  color: rgba(28, 28, 28, 1);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e5e5e5;
  padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/account_management/authentication.vue